<template>
    <div class="tpl-content-wrapper">
        <div class="tpl-portlet-components" v-for="dashboard in _dashboard_content.blocks"
             :key="dashboard.topic"
        >
            <div class="tpl-portlet-title">
                <div class="tpl-caption font-blue">
                    <i class="am-icon-dashboard"></i>
                    <span>应用场景</span>
                    <span class="desc">你可以点击下方应用场景，开启你的成长之路</span>
                </div>
                <div class="tpl-more mt-2">
                    <ul>
                        <li>
                            <router-link :to="{ path: 'main/apps'}" tag="a">更多
                            </router-link>
                            <!--<router-link tag="a" : to="{ name: 'dashboard', query: {'topic': dashboard.topic} }">更多-->
                            <!--</router-link>-->
                        </li>
                    </ul>
                </div>
            </div>
            <div class="dashboard_content_cards">
                <div class="dashboard_content_card_item"
                     v-for="md in dashboard.books"
                     :key="md.name"
                >
                    <DashboardCard :data="md">
                    </DashboardCard>
                </div>
            </div>
        </div>
    </div>
</template>
<script type="text/javascript">
    import DashboardCard from '@/components/common_components/cards/dashboard_card.vue'

    import {mapState} from 'vuex'

    export default {
        components: {
            DashboardCard
        },
        computed: {
            ...mapState({
                index_content: state => state.main.index_content,
                dashboard_content: state => state.mian.dashboard_content
            }),
            _dashboard_content: function () {
                if (!this.$route.query.topic) {
                    return this.index_content
                }
                // 好像没有上一页下一页的需求...
                let c = this.dashboard_content
                let newC = {
                    'previous': c.previous, 'next': c.next, blocks: [{
                        'topic': this.$route.query.topic,
                        'books': c.results
                    }]
                }
                return newC
            }
        }
    }
</script>
<style type="text/css" scoped>
    .libary_main_libray_div {
        width: 74%;
        margin-left: 15px;
        background: #fff;
        border: 1px solid #eee;
        padding: 15px;
    }

    .libary_main_libray_content_header {
        display: flex;
        justify-content: space-between;
        margin-bottom: 20px;
    }

    .dashboard_content_cards {
        display: flex;
        flex-wrap: wrap;
    }

    .dashboard_content_card_item {
        width: 33.3%;
        padding: 0 15px;
    }

    .user-lab-info-box {
        /*margin-bottom: 10px;*/
        /*padding: 28px 20px;*/
        /*background: #fff;*/
    }

    .user-lab-info-box > li > ul {
        margin: 8px 0;
        padding: 0;
    }

    .user-lab-info-box > li > ul > li:first-child {
        margin-right: 5px;
        width: 26px;
        height: 25px;
    }

    .user-lab-info-box > li > ul > li {
        display: inline-block;
        width: calc(100% - 36px);
        vertical-align: middle;
        font-size: 14px;
        color: #666;
    }

    .user-level .level-num {
        position: relative;
        display: inline-block;
        width: 100px;
        margin: 10px 10px 0 0;
        padding: 0 12px;
        vertical-align: bottom;
        line-height: 20px;
        font-size: 13px;
        border-radius: 10px;
        background: #ffc500;
        color: #292929;
    }

    .user-lab-info-box > li > ul > li.user-level p {
        margin: 5px 0;
        font-size: 12px;
        color: #a4a4a4;
        letter-spacing: 0;
    }

</style>